export default "/apps/maps/img/layers-2x.png";